import { render, staticRenderFns } from "./expanded-product-view.vue?vue&type=template&id=56514814&scoped=true"
import script from "./expanded-product-view.vue?vue&type=script&lang=js"
export * from "./expanded-product-view.vue?vue&type=script&lang=js"
import style0 from "./expanded-product-view.vue?vue&type=style&index=0&id=56514814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56514814",
  null
  
)

export default component.exports